<p-dialog
  *transloco="let t"
  [header]="engagement?.engagementName || ''"
  [visible]="showing"
  (visibleChange)="showingChange.emit($event)"
  [resizable]="false"
  [blockScroll]="true"
  appendTo="body"
  >
  <p-table
    *transloco="let t"
    [value]="engagementAccessEntries"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="['name', 'jobCode', 'managerName']"
    sortField=""
    [sortOrder]="-1"
    styleClass="p-datatable-sm log-table"
    dataKey="id"
    >
    <ng-template #header>
      <tr>
        <th pSortableColumn="engagementName">
          {{ t("name") }} <p-sortIcon field="engagementUserName"></p-sortIcon>
        </th>
        <th pSortableColumn="userType">
          {{ t("user_type") }} <p-sortIcon field="userType"></p-sortIcon>
        </th>
        <th colspan="2" pSortableColumn="jobCode">
          {{ t("email") }} <p-sortIcon field="engagementUserEmail"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template #body let-engagementEntry>
      <tr attr.data-instanceid="{{ engagementEntry.instanceId }}">
        <td>
          <span class="font-medium">{{
            engagementEntry.engagementUserName
          }}</span>
        </td>
        <td>
          <span>{{ engagementEntry.userType }}</span>
        </td>
        <td>
          <span>{{ engagementEntry.engagementUserEmail }}</span>
        </td>
        <td>
          @if (engagementEntry.userType != 'Manager') {
            <button
              pButton
              pRipple
              type="button"
              class="p-button-text p-button-loading-icon p-button-danger"
              icon="icon-close-fill -ml-1 -mt-2px"
              loadingIcon="animate-spin -ml-1 -mt-2px"
              [label]="t('revoke_access')"
              (click)="confirmRevokeAccess(engagementEntry)"
            ></button>
          }
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td [attr.colspan]="6">
          <p class="p-12 italic font-normal text-center text-grey-medium/50">
            {{ loading ? t("loading") : t("empty_message") }}
          </p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
